import { HttpInterceptorFn } from '@angular/common/http';
import { UserRolesService } from '../../services/user-roles.service';
import { inject } from '@angular/core';
import { SessionStorageService } from '../services/session-storage.service';

export const userRoleInterceptor: HttpInterceptorFn = (req, next) => {
  
  const sessionStorageService = inject(SessionStorageService);
  const currentRole = sessionStorageService.getItem('HighestRoleId');

  if (currentRole) {
    // Clone the request and add the role header
    const modifiedReq = req.clone({
      setHeaders: {
        'X-HighestRole': currentRole
      }
    });
    return next(modifiedReq);
  }

  return next(req);
};
